module.exports = __webpack_public_path__ + "static/media/Noah-Medium.b5d96156.woff";